import posthog from 'posthog-js';
import { setupPosthogOfflineIdb } from './services/PostHogOffline';

export function initAnalytics(settings: {
	PUBLIC_POSTHOG_KEY: string;
	PUBLIC_POSTHOG_HOST: string; // e.g. https://e.company.com
}) {
	posthog.init(settings.PUBLIC_POSTHOG_KEY, {
		api_host: settings.PUBLIC_POSTHOG_HOST,
		person_profiles: 'always',
		// capture_pageview: false, // if you send page() manually
	});

	const offline = setupPosthogOfflineIdb(posthog, {
		maxQueue: 5000,
		batchSize: 200,
		flushOnInit: true,
		enableConsoleDebug: false,
	});

	return {
		posthog,
		track: offline.capture,
		flush: offline.flushQueue,
		identify: (id: string, traits?: Record<string, any>) => posthog.identify(id, traits),
		page: (name?: string, props?: Record<string, any>) => offline.capture('$pageview', { name, ...props }),
	};
}

export default initAnalytics;
